<template>
	<ul v-if="loading" class="list">
		<li :key="i" v-for="(item, i) in items" class="item">
			<el-skeleton style="width: 100%" :loading="loading" animated>
				<template slot="template">
					<el-container>
						<div
							style="
								display: inline-flex;
								flex-direction: column;
								align-items: top;
								margin-left: 10px;
								margin-top: 5px;
							"
						>
							<el-skeleton-item
								style="
									width: 14px;
									height: 14px;
									margin-right: 5px;
									border-radius: 100%;
									margin-top: 4px;
								"
							/>
							<el-skeleton-item variant="text" style="height: 33px; width: 2px; margin-left: 6px" />
							<el-skeleton-item
								style="width: 14px; height: 14px; margin-right: 5px; border-radius: 100%"
							/>
						</div>
						<el-main style="padding: 0px; margin-left: 10px; width: 50%; margin-top: 5px; margin-top: 10px">
							<el-skeleton-item variant="text" style="width: 90%; margin-bottom: 29px" />
							<el-skeleton-item variant="text" style="width: 90%; margin-bottom: 10px" />
							<el-skeleton-item
								variant="text"
								style="width: 40%; height: 10px; position: absolute; left: 21px; bottom: 15px"
							/>
						</el-main>
					</el-container>
				</template>
			</el-skeleton>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		items: Number,
	},
};
</script>

<style scoped>
.list {
	margin: 0;
	list-style-type: none;
	padding: 2px;
}

.item {
	background-color: white;
	height: 133px !important;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 20px;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 10px;
	padding-bottom: 0px !important;
	padding-top: 0px !important;
	height: 117.5px;
}
</style>
